import React, { FC, memo } from 'react';
import FormikInput from '@minecraft.formik-input';
import { FilterData } from '../../shared/types';

type Props = FilterData;

const StageName: FC<Props> = ({ name, label }) => {
  return <FormikInput name={name} size="small" showLabel label={label} />;
};

export default memo(StageName);
